import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { FTL_WALKTHROUGH_COMPLETED, USER } from '../../constants/CommonConst';
import { walkthroughUtils } from '../../constants/WalkthroughConst';
import { signOut } from '../../utils/APIUtils';
import { notificationManager } from '../../utils/NotificationUtils';
import './First-Time-Login-Walkthrough.scss';
import { encryptLocalStorage, decryptLocalStorage } from '../../utils/authUtils';
const FirstTimeLoginWalkthrough = () => {
  const logo = '/assets/img/hudini-logo-black.png';
  const walkthroughDataSet = walkthroughUtils.getFirstTimeLoggedInWalkthrough();
  const [showContent, setShowContent] = useState(walkthroughDataSet[0]);
  const firstTimeLoggedWalkthroughCompleted = decryptLocalStorage(FTL_WALKTHROUGH_COMPLETED);

  const loggedinUser = decryptLocalStorage(USER);
  const history = useHistory();

  const onSlideChange = (pageNumber) => {
    if (pageNumber < 3) {
      setShowContent(walkthroughDataSet[pageNumber]);
    } else if (firstTimeLoggedWalkthroughCompleted && firstTimeLoggedWalkthroughCompleted.length) {
      firstTimeLoggedWalkthroughCompleted.push(loggedinUser.id);

      encryptLocalStorage(FTL_WALKTHROUGH_COMPLETED, firstTimeLoggedWalkthroughCompleted);

      history.push('/');
    } else {
      if (loggedinUser && loggedinUser.id) {
        const arr = [loggedinUser.id];
        encryptLocalStorage(FTL_WALKTHROUGH_COMPLETED, arr);
        history.push('/');
      } else {
        signOut();
        localStorage.removeItem('user');
        history.push('/prelogin');
        notificationManager('danger', 'Error while fethching logged in user. Please login again');
      }
    }
  };

  return (
    <div className='first-time-login-walkthrough'>
      <div className='row bg-white px-4 mx-0'>
        <div className='logo'>
          <img src={logo} className='header-logo' alt='logo' />
        </div>
      </div>
      <div className='row d-flex justify-content-center align-items-center content mx-0'>
        <div className='header-row d-flex justify-content-center'>
          <span>elevate</span>
        </div>
        <div className='content'>
          <img src={showContent.image} alt='img' className='item-image' />
          <div className='item-header'>
            <span>{showContent.header}</span>
          </div>
          <div className='item-description'>
            <span>{showContent.description}</span>
          </div>
        </div>
        <div className='d-flex justify-content-center slider'>
          <span
            className={`${showContent.currentPage === 0 ? 'active-slide' : 'slide'}`}
            onClick={(e) => onSlideChange(0)}
          ></span>
          <span
            className={`${showContent.currentPage === 1 ? 'active-slide' : 'slide'}`}
            onClick={(e) => onSlideChange(1)}
          ></span>
          <span
            className={`${showContent.currentPage === 2 ? 'active-slide' : 'slide'}`}
            onClick={(e) => onSlideChange(2)}
          ></span>
        </div>
      </div>
      <div className='d-flex justify-content-center action mx-0'>
        <img
          src={showContent.btnImage}
          alt='btn'
          onClick={(e) => onSlideChange(showContent.currentPage + 1)}
        />
      </div>
    </div>
  );
};

export default FirstTimeLoginWalkthrough;
